import { Component, Input } from "@angular/core";

@Component({
  selector: "ca-avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.scss"]
})
export class AvatarComponent {
  initials: "";
  @Input()
  set fullName(data) {
    if (!data) {
      this.initials = "";
    } else {
      this.initials = data
        .split(" ")
        .map(name => name.charAt(0))
        .join("");
    }
  }
  @Input()
  background: boolean;
  @Input()
  image: string;

  @Input()
  small: boolean;
}
